//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import GoogleReCaptcha from '../GoogleReCaptcha.vue';
import AuthForm from './AuthForm.vue';
import { OPEN_CONTACT_FORM_BENEFITS } from '~/constants/authFlows';
import { premiumStarPurple } from '~/static/icons';
export default {
    name: 'OpenContactForm',
    components: { AuthForm, GoogleReCaptcha },
    data() {
        return {
            // Constants
            OPEN_CONTACT_FORM_BENEFITS,

            // Icons
            premiumStarPurple
        };
    }
};
